import { render, staticRenderFns } from "./MenuSolid.vue?vue&type=template&id=3af8bf2b&"
import script from "./MenuSolid.vue?vue&type=script&lang=ts&"
export * from "./MenuSolid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports